import { Alert, Box, Button, Chip, TextField, Typography } from '@mui/material';
import { isSameParty, normalizeParty } from '../../../lib/packingListNormalize';
import { smallFieldSx } from 'shared/config/Styles';
import { headerMaxLength } from '../../../lib/packingListFields';
import ConfidenceMark from './ConfidenceMark';

/**
 * 운영값은 House의 Trade Partner다. House 값을 본문에 두고 PL 기재값은 보조 입력으로 둔다.
 * 정규화 후에도 다르면 경고를 띄우고 "Register as alias"로 그 표기를 별칭에 쌓는다. House 값 자체는 여기서 고치지 않는다.
 * readOnly면 PL 기재값을 고치지 못하고 Use House·Register as alias도 없다.
 */
export default function PartyCompareField({ field, label, houseParty, plValue, aliases = [], onPlChange, onRegisterAlias, highlight, readOnly = false, confidence = null }) {
    const houseName = houseParty?.name ?? '';
    const exact = !plValue || normalizeParty(plValue) === normalizeParty(houseName);
    const aliasMatch = !exact && isSameParty(houseName, plValue, aliases);
    const mismatch = Boolean(plValue && houseName && !exact && !aliasMatch);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, minWidth: 0 }}>
            <Typography sx={{ fontSize: 12, fontWeight: 500, color: '#003a52' }}>{label}</Typography>
            <Box sx={{ px: 1.25, py: 0.75, borderRadius: 1, border: '1px solid', borderColor: mismatch ? 'warning.main' : 'divider', bgcolor: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Typography sx={{ fontSize: 12, fontWeight: 500 }} noWrap title={houseName}>{houseName || '—'}</Typography>
                {exact && plValue && <Chip size="small" color="success" label="Match" sx={{ fontSize: 10, height: 18 }} />}
                {aliasMatch && <Chip size="small" color="success" variant="outlined" label="Alias match" sx={{ fontSize: 10, height: 18 }} />}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <Box sx={{ position: 'relative', flex: 1, minWidth: 0 }}>
                    <TextField size="small" fullWidth label="As written on PL" value={plValue ?? ''} onChange={(e) => onPlChange(e.target.value)} inputProps={{ maxLength: headerMaxLength(field) }} InputProps={{ readOnly }} InputLabelProps={{ shrink: true }} error={Boolean(highlight)} sx={smallFieldSx} />
                    <ConfidenceMark confidence={confidence} field={field} edited={false} />
                </Box>
                {houseName && !readOnly && <Button size="small" variant="outlined" onClick={() => onPlChange(houseName)} sx={{ fontSize: 11, whiteSpace: 'nowrap', height: 27 }}>Use House</Button>}
            </Box>
            {mismatch && (
                <Alert severity="warning" sx={{ py: 0, fontSize: 11, '& .MuiAlert-message': { display: 'flex', alignItems: 'center', gap: 1, width: '100%' } }} action={readOnly ? undefined : <Button size="small" color="inherit" onClick={() => onRegisterAlias(houseParty.id, plValue)} sx={{ fontSize: 11 }}>Register as alias</Button>}>
                    PL party name differs from House.
                </Alert>
            )}
        </Box>
    );
}
